module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../../node_modules/happypack/loader.js?id=jsx!./MyArchivesView.js"));
	}, "MyArchivesView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=MyArchivesView!./src/pages/Shop/Member/Personal/Account/MyArchives/MyArchivesView.js
// module id = 988
// module chunks = 438